import type { JSX } from 'preact';

export const canhBao = (): JSX.Element => (
  <>
    <path d="M12 3.5l9.5 16.5h-19z" />
    <path d="M12 10v4.5" />
    <circle cx="12" cy="17.3" r=".5" />
  </>
);
export const hoaDang = (): JSX.Element => (
  <>
    <path d="M3 19.5c2 1 4 1 6 0s4-1 6 0 4 1 6 0" />
    <path d="M12 16.5c-3.2 0-6-2-7-5 3 0 5.2 1.2 7 3 1.8-1.8 4-3 7-3-1 3-3.8 5-7 5z" />
    <path d="M12 14.2c-1.6-2-1.6-4.8 0-7 1.6 2.2 1.6 5 0 7z" />
  </>
);
export const kiem = (): JSX.Element => (
  <>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </>
);
export const sen = (): JSX.Element => (
  <>
    <path d="M12 19c-4 0-7.5-2.5-8.5-6.5 3.5 0 6.5 1.6 8.5 4 2-2.4 5-4 8.5-4-1 4-4.5 6.5-8.5 6.5z" />
    <path d="M12 15.5c-2-2.6-2-6.4 0-9.5 2 3.1 2 6.9 0 9.5z" />
  </>
);
export function Glyph(props: {
  of: () => JSX.Element;
  size?: number;
  class?: string;
}): JSX.Element {
  const size = props.size ?? 24;
  return (
    <svg
      class={props.class ? `ic ${props.class}` : 'ic'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      {props.of()}
    </svg>
  );
}

export function Spin(): JSX.Element {
  return <span class="spin" aria-hidden="true" />;
}
